/*global RdcTracking */
import { setupLdpClickTracking } from './ldp_clicks';
import { getPageName } from '../../shared/tracking_helper';
import { addOpenPanelsABTracking } from "../../../../quick_view/optimization/ab-open-panels";

const DEFAULT_VALUE = 'unknown';

export const setupLdpPageTracking = function() {
  if (MOVE_DATA && MOVE_DATA.adobeDTM) {
    const pageName = getPageName(MOVE_DATA.adobeDTM.pageType, MOVE_DATA.adobeDTM.propertyStatus);
    const pageStatus = getPageName(MOVE_DATA.adobeDTM.pageType, MOVE_DATA.adobeDTM.propertyStatus, true)
    trackPageLoad(pageName);
    deleteListingClickSourceCookie();
    setupLdpClickTracking(pageStatus);
  }
};

export const handleFullLdpAccordionClicks = function() {
  const isABFullLdpModules      = MOVE_DATA.full_ldp_modules === 'V1' || MOVE_DATA.full_ldp_modules === 'V2';
  const timeout                 = 500;  
  let accordionsClass           = '.accordion-heading';
  if (isABFullLdpModules) {
    accordionsClass = '.full-ldp-collasped-accordion';
  }
  const accordionsClasses = $(accordionsClass);
  accordionsClasses.each(function() {
    let updatedOmtag;
    const accordion = $(this);
    if (accordion) {
      accordion.on('click', function() {        
        //recalculating right rails ad space during expanding and collapsing
        if (isABFullLdpModules) {
          setTimeout(() => { 
            MOVE.LDP.RightRailBC.getAdPosition();
          }, timeout);
        }
        const omtag = accordion.data('omtag');
        if (omtag) {
          if (accordion.hasClass('collapsed')) {
            updatedOmtag = omtag.replace(/expand/, 'collapse');
          } else {
            updatedOmtag = omtag.replace(/collapse/, 'expand');
          }
          if (updatedOmtag) accordion.attr('data-omtag', updatedOmtag);
        }
      });
    }
  });
}

const deleteListingClickSourceCookie = function() {
  if($.cookie("SrpClickedListing")) {
    $.removeCookie("SrpClickedListing", { path: '/' });
  }
};

const trackPageLoad = function(pageName) {
  RdcTracking.trackPage(pageName, prepareLoadEventData(MOVE_DATA.adobeDTM));
};

const prepareLoadEventData = function (pageData) {
  var pageType = pageData['pageType'];
  var listing = pageData['listing'] || {};
  var data =
    {
      additionalRRComId: pageData['additionalRR-comID'],
      additionalRRListingId: pageData['additionalRR-listingID'],
      advertiserIdAgent: pageData['advertiserID-agent'],
      advertiserIdBroker: pageData['advertiserID-broker'],
      advertiserIdListing: pageData['advertiserID-listing'],
      advertiserIdLocal: pageData['advertiserID-local'],
      advertiserIdOffice: pageData['advertiserID-office'],
      appVersion: pageData['appVersion'],
      city: pageData["listingCity"] || DEFAULT_VALUE,
      communityId: pageData["communityId"] || DEFAULT_VALUE,
      dsProducts: pageData["dataScienceProducts"],
      ldpPropertyStatus: getLdpPropertyStatus(pageType, pageData.propertyStatus, pageData.propertyStatusSub) || DEFAULT_VALUE,
      leadDelivery: listing["leadDelivery"],
      leadEnhancements: getLeadEnhancements(),
      listingActivity: attrWithPageType(pageData["listingActivity"], pageType),
      listingBaths: pageData['listingBaths'],
      listingBeds: pageData['listingBeds'],
      listingClickSource: getListingClickSource(),
      listingEnhancements: listing["enhancements"] || DEFAULT_VALUE,
      listingId: pageData["listingID"] || DEFAULT_VALUE,
      listingMls: pageData["listingSource"] || DEFAULT_VALUE,
      listingPrice: pageData["listingPrice"] || DEFAULT_VALUE,
      listingSqFt: pageData['listingSqFt'],
      mprId: pageData["mprID"] || DEFAULT_VALUE,
      neighborhood: pageData["listingNeighborhood"],
      pageId: pageData["pageID"],
      pageType: pageType,
      photoCount: pageData["listingPhotoCt"] || DEFAULT_VALUE,
      planId: pageData["planID"] || DEFAULT_VALUE,
      productType: attrWithPageType(pageData["productType"], pageType),
      propertyStatus: getPropertyStatus(pageData["propertyStatus"], pageType) || DEFAULT_VALUE,
      propertyStatusSub: pageData["propertyStatusSub"] || DEFAULT_VALUE,
      propertyType: attrWithPageType(pageData["propertyType"], pageType) || DEFAULT_VALUE,
      rankingOnSrp: pageData["listingRank"] || DEFAULT_VALUE,
      realtipPresent: pageData["realtipPresent"] || 'n',
      realtipCount: pageData["realtipCount"],
      rentalDataSource: pageData["dataSourceType"] || DEFAULT_VALUE,
      roleType: pageData["roleType"],
      searchId: pageData["searchID"],
      sellerPromo: pageData["sellerPromotion"] === true ? 'y': 'n',
      siteSection: getPageName(pageType, pageData["propertyStatus"], true),
      smartBanner: pageData["smartBanner"] || 'n',
      state: pageData["listingState"] || DEFAULT_VALUE,
      subId: pageData["subID"] || DEFAULT_VALUE,
      zip: pageData["listingZip"] || DEFAULT_VALUE,
      tempLdpConfig: addOpenPanelsABTracking(),
      imageSwapped: MOVE_DATA.qv_imgctr_swapped === true ? 'y' : 'n',      
    };
    if (pageType === "ldp-quickview") {
      // LGWEB-40
      if(MOVE_DATA.ab_vitality) {
        data['vitalityWidgetImpression'] = `views_on_rdc_${pageData.property_vitality && pageData.property_vitality['ldp_pageview_count'] > 0 ? 'y': 'n'}:saved_${pageData.property_vitality && pageData.property_vitality['saved_count'] > 0 ? 'y': 'n'}:shared_${pageData.property_vitality && pageData.property_vitality['shares_count'] > 0 ? 'y': 'n'}`
      }
      // LGWEB-40
      return Object.assign({}, data, { abTestSrp: getAbTestVariables() });
    } else {
      return Object.assign({}, data, { abTestLdp: getAbTestVariables() });
    }
};

const getListingClickSource = () => {
  let presentCookieValue = '';
  if($.cookie("SrpClickedListing")) {
    presentCookieValue = JSON.parse($.cookie("SrpClickedListing")).src;
  }
  return presentCookieValue;
};

const attrWithPageType = function(attr, pageType) {
  if (attr) {
    return `${pageType}:${attr}`;
  }
};

const getAbTestVariables = function() {
  var elems = document.querySelectorAll("input[data-optimizely]");
  var retValue = '';
  for (var i = 0; i < elems.length; i++) {
    if ( i > 0 ) { retValue += ',' }
    retValue += elems[i].getAttribute("data-optimizely");
  }
  return retValue;
};

const getPropertyStatus = function(propertyStatus, pageType) {
  return pageType === 'bdp' ? null : propertyStatus;
}

const getLdpPropertyStatus = function(pageType, propertyStatus, propertyStatusSub) {
  if (pageType === 'bdp') {
    return;
  }
  return propertyStatusSub ? `${pageType}:${propertyStatus}:${propertyStatusSub}` : `${pageType}:${propertyStatus}`;
};

const getLeadEnhancements = function() {
  if (!MOVE_DATA.propertyDetails ||
    !MOVE_DATA.propertyDetails.lead_attributes ||
    !MOVE_DATA.propertyDetails.lead_attributes.lead_type ||
    MOVE_DATA.propertyDetails.lead_attributes.lead_type === 'none'){
    return '';
  }
  return MOVE_DATA.propertyDetails.lead_attributes.show_contact_a_lender ? MOVE_DATA.is_lcm_enabled ? 'classic,lcm' : 'classic,rcm' : 'classic';
};



// WEBPACK FOOTER //
// ./shared_critical/tracking/pages/ldp/ldp_page_load.js